import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter, ViewChild, NgZone, ElementRef } from '@angular/core';
import { QueryProcessorService } from '../services/query-services/query-processor.service';
import { QueryFormService } from '../services/query-services/query-form/query-form.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import * as moment from 'moment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { StandardUIService } from '../services/standardui-service/standardui-service';
import { MetaData } from '../services/metadata/metadata.service';
import { ObjectController } from '../services/object-controller/objectcontroller.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CryptoService } from '../services/crypto-services/crypto-services';
import { DomSanitizer, Title, Meta } from '@angular/platform-browser';
import { AgentscriptService_updated } from '../services/agent-script-service/agent-script-service';

declare var $: any;
require('../../assets/vendor/js/dataTableDateSorting.js');

export class QueryResults {
  id: number;
  firstName: string;
  lastName: string;
  dob: string;
}

@Component({
  selector: 'app-query-builder-processor',
  templateUrl: './query-builder-view.component.html',
  styleUrls: ['./query-builder-view.component.scss']
})

export class QueryBuilderViewComponent implements OnInit, AfterViewInit {
  brodCastChnage: BehaviorSubject<any> = new BehaviorSubject(null);
  private subscription: Subscription;
  @Input() componentContext;
  @Input() entitydata;
  @Output() componentSelection = new EventEmitter<any>();
  @Input() reportId;
  @Input() context;
  searchKeys = ['id', 'firstName', 'lastName', 'dob'];
  sortBy = 'firstName';
  sortDesc = false;
  perPage:any = 100;
  pageNo = 1;
  totalItems = 0;
  filterVal = '';
  currentPage = 1;
  infoMsg: boolean;
  loading: boolean = false;
  outputData: any;
  entity: string;
  originalQueryProcessorArray = [];
  queryProcessorArray: QueryResults[] = [];
  queryProcessorFormGroup: FormGroup;
  submitted = false;
  offset:any = 0;
  reportData: any = [];
  headings: any;
  rowData: any = [];
  editReportForm: FormGroup;
  fbGpObject: any = {};
  tabName: string;
  cols: any = [];
  rows: any = [];
  objectMetaData: any;
  editEnityName: string;
  editID: number;
  containerHeight: any;
  otherStyles = {};
  tbody = {};
  tcontainer = {};
  randomTableIds: any;
  queryBuilderEnityName:any;
  openNewChild:boolean = false;
  referredEntity:string;
  referredColumn:string;
  noData:boolean = false;
  searchtext: any;
  /** Snapshot of API rows for the current page (before toolbar search / column sort). */
  reportApiRowData: any[][] = [];
  reportSortColumnIndex: number | null = null;
  reportSortAscending = true;
  /** When true, shows the "Search for Report" toolbar (hidden by default in embedded query-builder view). */
  showReportSearchToolbar = false;
  @ViewChild('reportPopupForm') public reportPopupForm;
  @ViewChild('queryBuilderRoot', { static: true }) queryBuilderRoot: ElementRef;
  private intersectionObserver?: IntersectionObserver;
  isInViewport: boolean = false;
  public isCollapsed = false;
  constructor(
    private queryProcessorService: QueryProcessorService,
    private spinnerService: SpinnerVisibilityService,
    private formBuilder: FormBuilder,
    private queryFormsService: QueryFormService,
    private modalService: NgbModal,
    private sus: StandardUIService,
    private metadata: MetaData,
    private objc: ObjectController,
    private cryptoService: CryptoService,
    public sanitizer: DomSanitizer,
    private _ngZone: NgZone,
    private agentscriptservice:AgentscriptService_updated
  ) {

  }

  ngOnInit() {
   // console.log(this.entitydata);
   // console.log('cid', this.componentContext);
    if (this.componentContext != null && this.componentContext.id) {
      //console.log('cid', this.componentContext);
      this.componentContext.randomid = this.randomId();
    }
    this.queryProcessorFormGroup = this.queryFormsService.toFormGroup(this.originalQueryProcessorArray);
    let navbarH = $('.layout-navbar').height();
    let docH = $(window).height();
    this.containerHeight = (docH - navbarH - 295) + 'px';

    this.tcontainer = {
      'height': this.containerHeight
    };
    
  }

  ngAfterViewInit() {
    this.intersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        this.isInViewport = entry.isIntersecting;
        if (this.isInViewport) {
         // console.log('Query Builder is in the viewport!');
          this.reloadPage();
          //alert('Query Builder is in the viewport!');
          // Add your logic here
        } else {
         // console.log('Query Builder is NOT in the viewport!');
          //alert('Query Builder is NOT in the viewport!');
        }
      });
    }, { threshold: 0.1 }); // 0.1 = 10% visible

    if (this.queryBuilderRoot && this.queryBuilderRoot.nativeElement) {
      this.intersectionObserver.observe(this.queryBuilderRoot.nativeElement);
    }

    // var tableCont = document.querySelector('.fixed_header')

    // function scrollHandle (e){
    //   var scrollTop = this.scrollTop;
    //   this.querySelector('thead').style.transform = 'translateY(' + scrollTop + 'px)';
    // }

    // tableCont.addEventListener('scroll',scrollHandle)
    
    let self = this;   
    if(typeof self.entitydata.id == 'string'){
        setTimeout(() => {
        this.noData = true;
        });
     } 
 
    if (self.entitydata.id > 0) {
      self.queryProcessorService.getQueriesServiceV2(this.componentContext.id).subscribe(data => {
        //console.log(data);
        this.openNewChild = data.addNew;
        if(this.openNewChild){this.referredEntity = data.referredEntity;this.referredColumn = data.referredColumn}
        self.originalQueryProcessorArray = data.inputs;
        if (data.inputs.length > 0) {
          self.originalQueryProcessorArray = data.inputs.sort(function (obj1, obj2) {
            return obj1.sequenceOrder - obj2.sequenceOrder;
          });
        }

        let hiddenFilters = true;

        for (var i = 0; i < data.inputs.length; i++) {
          if (data.inputs[i].hidden == false) {
            hiddenFilters = false;
            break;
          }
        }


        //console.log('originalQueryProcessorArray ', this.originalQueryProcessorArray);

        self.queryProcessorFormGroup = this.queryFormsService.toFormGroup(this.originalQueryProcessorArray);
        // if (hiddenFilters)
        //   self.getFilteredData(0);
      },
        error => {
          //console.log('error in getQueriesService');
        });
    }
    // Open Report Start 
    //$(document).on("click", ".openReport", function (e) {
      // Namespace for this instance
      const ns = `.qbv_${this.componentContext.randomid}`;

      // Remove any previous handlers for this instance
      $(document).off(ns);

      $(document).on('click' + ns, '#data-table'+this.componentContext.randomid+'_wrapper .openReport', function (e) {
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let row: any = JSON.parse(self.cryptoService.get($(this).data('row')));
      if(item.colaction == 'Open'){
        for(let i =0;i < row.length;i++){
          if(row[i].dataType == "ACTION" && row[i].action.actionType == item.colaction){
            item = row[i];
          }
        }
      }
     // console.log(row);
     // console.log(item)
      var refferencecolumn;
      refferencecolumn=row.filter((x:any)=> (x.fieldName && x.fieldName.toString().includes("refno")))
      // row=row.filter((x:any)=> x.fieldName==="i.refno")

     // console.log(refferencecolumn)
     // console.log(row)
      // tabName + '-' + item.action.value
      let tabName: any = $(this).data('tabname');
      switch (tabName) {
        case "Answer": 
        this.saveAgentRecentAccesspayload={"answerid":item.action.value}
          break;
        case "Contact": 
        this.saveAgentRecentAccesspayload={"contactid":item.action.value}
          break;
        case "Incident": 
        this.saveAgentRecentAccesspayload={"incidentid":item.action.value}
          break;
      }
      self.sus.saveAgentRecentAccess(this.saveAgentRecentAccesspayload).subscribe((data:any)=>{
       // console.log(data)
        self.agentscriptservice.agentrecentaccess()
      })
      if(tabName == 'Contact'){
        let fullname = [];
        row.forEach((item)=>{
          if(item.fieldName){
            if(item.fieldName.includes('firstname') || item.fieldName.includes('lastname')){
              fullname.push(item.value);
            }
          }
        })   
        tabName = fullname.join(" ");
      }
      // let pageName;
      // row.forEach((item)=>{
      //   if(item.dataType == 'ACTION' && item.action.actionType == 'Hide'){
      //     pageName = item.action.value
      //   }
      // })      
      let d;
      if(refferencecolumn.length==0){
         d = {id: item.action.value, name:tabName+'-'+item.action.value, type:'object', entityName:item.action.entityName,department:item.action.entityName};
      }else{
         d = { id: item.action.value, name: refferencecolumn[0].value, type: 'object', entityName: item.action.entityName,department: item.action.pagevalue};
      }
      //d = { id: item.action.value, name: refferencecolumn[0].value, type: 'object', entityName: item.action.entityName,department: row[row.length-1].action.value};
      
     // console.log(d);
      //console.log(row[row.length-1].action.value);

      self.componentSelectionEmitter(d);
    })
    // Open Report End
    // Open Child Start 
    $(document).on('click' + ns, '.openChild', function (e) {
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let d = { id: item.value, name: item.objectName + '-' + item.value, type: 'object', entityName: item.objectName };
      self.componentSelectionEmitter(d);
    })
    // Open Child End
    // Edit Report Start
    $(document).off('click' + ns, '#data-table'+this.componentContext.randomid+'_wrapper').on('click' + ns, '#data-table'+this.componentContext.randomid+'_wrapper .editReport', function (e) {      
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let itemCols: any = JSON.parse(self.cryptoService.get($(this).data('cols')));
      let itemRow: any = JSON.parse(self.cryptoService.get($(this).data('row')));
      self.edit(itemRow, item.action.entityName, item.action.value, itemCols);
    })
    //Edit Report End
    //Delete
    $(document).off('click' + ns, '.deleteReport').on('click' + ns, '.deleteReport', function (e) {
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let itemCols: any = JSON.parse(self.cryptoService.get($(this).data('cols')));
      let itemRow: any = JSON.parse(self.cryptoService.get($(this).data('row')));            
      self.deleteRecord(item);
    })
    //Delete
    //Link Report Start
    //$(document).off('click', '.linkReport').on('click','.linkReport',function(e){
    $(document).on('click' + ns, '.linkReport', function (e) {
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      let tabName: any = $(this).data('tabname');
      let itemCols: any = JSON.parse(self.cryptoService.get($(this).data('cols')));
      let itemRow: any = JSON.parse(self.cryptoService.get($(this).data('row')));
      let d = { id: item.action.value, name: 'ManualLink-' + tabName + '-' + item.action.value, type: 'reportlink', entityName: item.action.entityName, rowData: itemRow, headings: itemCols }
      self.componentSelectionEmitter(d);
    })
    // Link Report End

    //Mark as case Start
    $(document).on('click' + ns, '.markcase', function (e) {
      let item: any = JSON.parse(self.cryptoService.get($(this).data('obj')));
      self.markAsCase(item.action.value);
    })
    //Mark as case End

    //Fixed Table header start
    $("div.table-cont" + this.componentContext.randomid).off(`scroll${ns}`).on(`scroll${ns}`, function () {
      let scrollTop: any = $(this).scrollTop();
      let x = $(this).find('table').position();
      let b = $(this).find('.btn-wrapper').position();
      if (scrollTop > 0) {
        $(this).find('thead tr th').css({ 'position': 'sticky', 'top': x.top, 'background-color': 'white' }).addClass('sticky');
        $(this).find('.btn-wrapper').css({ 'position': 'sticky', 'top': '0px', 'background-color': 'white' }).addClass('sticky');
        //$(this).find('thead').css({'transform' : 'translateY(' + scrollTop + 'px)','background':'white','width':'100%'});    
        //$(this).find('.btn-wrapper').css({'transform' : 'translateY(' + scrollTop + 'px)'});    
      } else {
        //let x = $(this).find('thead').position();
        //console.log("Top: " + x.top + " Left: " + x.left);
        $(this).find('thead tr th').css({ 'position': 'relative', 'top': 'auto' }).removeClass('sticky');
        $(this).find('.btn-wrapper').css({ 'position': 'relative', 'top': 'auto' }).removeClass('sticky');
        //$(this).find('thead').css({'transform' : 'translateY(' + scrollTop + 'px)','background':'white','width':'auto'});
        //$(this).find('.btn-wrapper').css({'transform' : 'translateY(' + scrollTop + 'px)'}); 
      }
    });
    //Fixed Table header end
  }

  ngOnDestroy() {
    // Remove all event handlers for this instance
    if (this.componentContext && this.componentContext.randomid) {
      $(document).off(`.qbv_${this.componentContext.randomid}`);
      $("div.table-cont" + this.componentContext.randomid).off(`scroll.qbv_${this.componentContext.randomid}`);
      // Dispose tooltips and destroy DataTable for this instance
      try { $(`#data-table${this.componentContext.randomid} [data-toggle='tooltip']`).tooltip('dispose'); } catch {}
      try {
        const sel = `#data-table${this.componentContext.randomid}`;
        if ($.fn.dataTable && $.fn.dataTable.isDataTable(sel)) {
          ($(sel) as any).DataTable().destroy(true);
          $(sel).empty();
        }
      } catch {}
    }
    if (this.intersectionObserver && this.queryBuilderRoot && this.queryBuilderRoot.nativeElement) {
      this.intersectionObserver.unobserve(this.queryBuilderRoot.nativeElement);
      this.intersectionObserver.disconnect();
    }
    // Unsubscribe active data subscription
    try { this.subscription && this.subscription.unsubscribe && this.subscription.unsubscribe(); } catch {}
  }
  deleteRecord(data){
    this._ngZone.run(() => {
     // console.log(data.action.entityName,data.action.value);
      Swal.fire({
        title: 'Do you want to delete this?',
        //showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Delete',
        //denyButtonText: `Don't save`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
       // console.log(result);
        if (result.value) {
          this.queryProcessorService.delete(data.action.entityName,data.action.value).subscribe(res=>{
            Swal.fire('Deleted Successfully!', '', 'success');
            this.refresh();
          });        
        } else if (result.dismiss == 'cancel') {
          //Swal.fire('Changes are not saved', '', 'info')
        }
      })
    })  
  }
  markAsCase(id) {

  }
  rowObj: any = {};
  customSortCols = [];

  get reportApiRowTotal(): number {
    return this.reportApiRowData?.length ?? 0;
  }

  /** Toolbar "Search for Report" — filters current page rows (client-side). */
  onReportToolbarSearch(): void {
    this.applyReportFilterAndSort();
  }

  onReportHeaderSort(colIndex: number, event: MouseEvent): void {
    const t = event?.target as HTMLElement | null;
    if (t?.closest('input')) {
      return;
    }
    if (!this.isReportColumnSortable(colIndex)) {
      return;
    }
    if (this.reportSortColumnIndex === colIndex) {
      this.reportSortAscending = !this.reportSortAscending;
    } else {
      this.reportSortColumnIndex = colIndex;
      this.reportSortAscending = true;
    }
    this.applyReportFilterAndSort();
  }

  isReportColumnSortable(colIndex: number): boolean {
    const cols = this.outputData?.cols as string[] | undefined;
    const rows = this.reportApiRowData;
    if (!cols?.length || !rows?.length) {
      return false;
    }
    if (colIndex < 0 || colIndex >= cols.length) {
      return false;
    }
    const label = String(cols[colIndex] ?? '').trim();
    const skipLabels = ['#', 'Multiselect', 'Action(s)', '', 'Select ALL', 'Select ALLs', 'Favourite'];
    if (skipLabels.includes(label)) {
      return false;
    }
    const meta = rows[0][colIndex];
    if (!meta || typeof meta !== 'object') {
      return false;
    }
    if (meta.colName === 'hidesort') {
      return false;
    }
    if (meta.dataType === 'ACTION') {
      return false;
    }
    return true;
  }

  /**
   * Client-side filter (toolbar "Search for Report") + optional column sort.
   * Rebuilds the jQuery DataTable body from {@link reportApiRowData}.
   */
  private applyReportFilterAndSort(): void {
    if (!this.outputData) {
      return;
    }
    const src = this.reportApiRowData;
    if (!src?.length) {
      this.outputData.rowData = [];
      this.renderReportTableWithDataTable('');
      return;
    }

    const q = String(this.searchtext ?? '')
      .trim()
      .toLowerCase();
    let rows = src.map((r) => r.slice());
    if (q) {
      rows = rows.filter((row) => this.reportRowMatchesSearch(row, q));
    }
    if (this.reportSortColumnIndex != null && rows.length > 0) {
      const col = this.reportSortColumnIndex;
      const dir = this.reportSortAscending ? 1 : -1;
      rows.sort((a, b) => this.compareReportRowsAtColumn(a, b, col) * dir);
    }

    this.outputData.rowData = rows;
    const tableTr = rows.length ? this.buildReportTableHtml(rows) : '';
    this.renderReportTableWithDataTable(tableTr);
  }

  private reportRowMatchesSearch(row: any[], q: string): boolean {
    return this.buildReportRowSearchHaystack(row).includes(q);
  }

  private buildReportRowSearchHaystack(row: any[]): string {
    const parts: string[] = [];
    for (const cell of row) {
      parts.push(this.reportCellSearchFragment(cell));
    }
    return parts.join(' ').toLowerCase();
  }

  private reportCellSearchFragment(cell: any): string {
    if (!cell || typeof cell !== 'object') {
      return '';
    }
    const dt = cell.dataType;
    if (dt === 'ACTION') {
      const a = cell.action;
      if (!a) {
        return '';
      }
      return [a.actionType, a.value, a.pagevalue, a.entityName, a.columnName]
        .filter((x) => x != null && x !== '')
        .map(String)
        .join(' ');
    }
    if (dt === 'Boolean') {
      return cell.value ? 'yes true 1' : 'no false 0';
    }
    if (!cell.hasOwnProperty('value')) {
      return '';
    }
    const v = cell.value;
    if (v === null || v === undefined || v === '') {
      return '';
    }
    if (dt === 'Date') {
      return `${this.sus.getDateByFormat(v, '/', 'mdy')} ${v}`;
    }
    if (dt === 'DateTime') {
      return `${v ? this.sus.convertToEST(v) : ''} ${v}`;
    }
    return String(v);
  }

  private compareReportRowsAtColumn(a: any[], b: any[], colIndex: number): number {
    const ca = a[colIndex];
    const cb = b[colIndex];
    const head =
      (this.reportApiRowData?.[0] ?? this.outputData?.rowData?.[0])?.[colIndex];
    const dt = (head?.dataType ?? ca?.dataType ?? 'Text') as string;

    const emptyA = this.isReportSortValueEmpty(ca);
    const emptyB = this.isReportSortValueEmpty(cb);
    if (emptyA && emptyB) {
      return 0;
    }
    if (emptyA) {
      return 1;
    }
    if (emptyB) {
      return -1;
    }

    const va = ca.value;
    const vb = cb.value;

    switch (dt) {
      case 'Date':
      case 'DateTime':
        return this.compareReportNumericTimestamps(va, vb);
      case 'Number':
        return this.compareReportNumberValues(va, vb);
      case 'Boolean':
        return va === vb ? 0 : va ? 1 : -1;
      case 'Multiselect':
        return this.compareReportNumberValues(va, vb);
      default:
        return String(va).localeCompare(String(vb), undefined, {
          numeric: true,
          sensitivity: 'base'
        });
    }
  }

  private isReportSortValueEmpty(cell: any): boolean {
    if (cell == null || typeof cell !== 'object') {
      return true;
    }
    if (!cell.hasOwnProperty('value')) {
      return true;
    }
    const v = cell.value;
    return v === null || v === undefined || v === '';
  }

  private compareReportNumericTimestamps(va: any, vb: any): number {
    const ta = this.coerceReportTimeNumber(va);
    const tb = this.coerceReportTimeNumber(vb);
    return ta - tb;
  }

  private coerceReportTimeNumber(v: any): number {
    const n = Number(v);
    if (Number.isFinite(n) && !Number.isNaN(n)) {
      return n;
    }
    if (typeof v === 'string' && v.trim() !== '') {
      const p = Date.parse(v);
      if (!Number.isNaN(p)) {
        return p;
      }
    }
    return 0;
  }

  private compareReportNumberValues(va: any, vb: any): number {
    const sa = String(va).trim();
    const sb = String(vb).trim();
    const na = Number(va);
    const nb = Number(vb);
    if (
      sa !== '' &&
      sb !== '' &&
      Number.isFinite(na) &&
      Number.isFinite(nb) &&
      !Number.isNaN(na) &&
      !Number.isNaN(nb)
    ) {
      return na - nb;
    }
    return sa.localeCompare(sb, undefined, { numeric: true, sensitivity: 'base' });
  }

  /** Builds tbody HTML for DataTables from row matrix (same rules as legacy loop). */
  private buildReportTableHtml(rowMatrix: any[][]): string {
    const cols = this.outputData.cols;
    let tableTr = '';
    for (let j = 0; j < rowMatrix.length; j++) {
      tableTr += '<tr>';
      for (let k = 0; k < rowMatrix[j].length; k++) {
        if (rowMatrix[j][k].dataType == 'Date') {
          tableTr += '<td class="">' + this.sus.getDateByFormat(rowMatrix[j][k].value, '/', 'mdy') + '</td>';
        } else if (rowMatrix[j][k].dataType == 'DateTime') {
          if (rowMatrix[j][k].value) {
            tableTr += '<td class="">' + this.sus.convertToEST(rowMatrix[j][k].value) + '</td>';
          } else {
            tableTr += '<td class=""></td>';
          }
        } else if (rowMatrix[j][k].dataType == 'Boolean') {
          if (rowMatrix[j][k].value) {
            tableTr += '<td class=""><input title="' + rowMatrix[j][k].value + '" type="checkbox" value="" checked readonly />';
            tableTr += '<span style="visibility: hidden">' + rowMatrix[j][k].value + '</span></td>';
          } else {
            tableTr += '<td class=""><input title="' + rowMatrix[j][k].value + '" type="checkbox" value="" readonly />';
            tableTr += '<span style="visibility: hidden">&nbsp;</span></td>';
          }
        } else if (rowMatrix[j][k].dataType == 'ACTION' && rowMatrix[j][k].action.actionType != 'Hide') {
          if (rowMatrix[j][k].action.actionType == 'Edit') {
            tableTr +=
              '<td class=""><button data-cols=' +
              this.cryptoService.set(cols) +
              ' data-row=' +
              this.cryptoService.set(rowMatrix[j]) +
              ' data-obj=' +
              this.cryptoService.set(rowMatrix[j][k]) +
              ' class="btn btn-outline-primary btn-xs editReport">Edit</button></td>';
          }
          if (rowMatrix[j][k].action.actionType == 'Open') {
            tableTr +=
              '<td class=""><button data-tabname="' +
              this.tabName +
              '" data-obj=' +
              this.cryptoService.set(rowMatrix[j][k]) +
              ' data-row=' +
              this.cryptoService.set(rowMatrix[j]) +
              ' class="btn btn-outline-primary btn-xs openReport">Open</button></td>';
          }
          if (rowMatrix[j][k].action.actionType == 'Link') {
            tableTr +=
              '<td class=""><button data-tabname="' +
              this.tabName +
              '" data-cols=' +
              this.cryptoService.set(cols) +
              ' data-row=' +
              this.cryptoService.set(rowMatrix[j]) +
              ' data-obj=' +
              this.cryptoService.set(rowMatrix[j][k]) +
              ' class="btn btn-outline-primary btn-xs linkReport">Link</button></td>';
          }
          if (rowMatrix[j][k].action.actionType == 'DCCase') {
            tableTr +=
              '<td class=""><button data-tabname="' +
              this.tabName +
              '" data-cols=' +
              this.cryptoService.set(cols) +
              ' data-row=' +
              this.cryptoService.set(rowMatrix[j]) +
              ' data-obj=' +
              this.cryptoService.set(rowMatrix[j][k]) +
              ' class="btn btn-outline-primary btn-xs markcase">Mark as a case</button></td>';
          }
          if (rowMatrix[j][k].action.actionType == 'Delete') {
            tableTr +=
              '<td class=""><button data-cols=' +
              this.cryptoService.set(cols) +
              ' data-row=' +
              this.cryptoService.set(rowMatrix[j]) +
              ' data-obj=' +
              this.cryptoService.set(rowMatrix[j][k]) +
              ' class="btn btn-outline-primary btn-xs deleteReport">Delete</button></td>';
          }
        } else {
          if (rowMatrix[j][k].hasOwnProperty('value')) {
            if (rowMatrix[j][k].hasOwnProperty('objectName')) {
              if (rowMatrix[j][k].objectName == 'Person') {
                tableTr +=
                  '<td class=""><a href="javascript:void(0)" data-obj=' +
                  this.cryptoService.set(rowMatrix[j][k]) +
                  ' class="btns btn-outline-primarys btn-xss openChild">' +
                  rowMatrix[j][k].value +
                  '</a></td>';
              } else {
                if (rowMatrix[j][k].action && rowMatrix[j][k].action.actionType == 'Hide') {
                  tableTr += '<td class="d-none">' + rowMatrix[j][k].value + '</td>';
                } else {
                  if (rowMatrix[j][k].colName == 'casetype') {
                    if (rowMatrix[j][k].value.length > 20) {
                      tableTr +=
                        '<td class=""><img style="width:22px;" src="assets/images/casetypeImage/' +
                        rowMatrix[j][k].value.replace(/\s|\/+/g, '').toLowerCase() +
                        '.svg"> <span data-toggle="tooltip" title="' +
                        rowMatrix[j][k].value +
                        '">' +
                        rowMatrix[j][k].value.substring(0, 20) +
                        '...</span></td>';
                    } else {
                      tableTr +=
                        '<td class=""><img style="width:22px;" src="assets/images/casetypeImage/' +
                        rowMatrix[j][k].value.replace(/\s|\/+/g, '').toLowerCase() +
                        '.svg"> ' +
                        rowMatrix[j][k].value +
                        '</td>';
                    }
                  } else if (rowMatrix[j][k].colName == 'incidentstatus') {
                    const status = {
                      Unresolved: 'unresolved',
                      Resolved: 'resolved',
                      'Closed-Disregard': 'closeddisregard',
                      Reopen: 'reopen-sr',
                      'Close-Resolved': 'closeresolved',
                      Waiting: 'wating-sr',
                      Open: 'open-sr',
                      'Close-Reclassify': 'close-reclassify'
                    };
                    tableTr +=
                      '<td class="' +
                      status[rowMatrix[j][k].value] +
                      '"><span>' +
                      rowMatrix[j][k].value +
                      '</span></td>';
                  } else if (rowMatrix[j][k].dataType == 'Multiselect') {
                    tableTr +=
                      '<td class=""><input class="checkrow" data-tabname="' +
                      this.tabName +
                      '" data-cols=' +
                      this.cryptoService.set(cols) +
                      ' data-row=' +
                      this.cryptoService.set(rowMatrix[j]) +
                      ' type="checkbox" name="check"></td>';
                  } else {
                    if (rowMatrix[j][k].value?.length > 20) {
                      if (rowMatrix[j][k].colaction == 'Open') {
                        tableTr +=
                          '<td><a class="openReport" data-tabname="' +
                          this.tabName +
                          '" data-obj=' +
                          this.cryptoService.set(rowMatrix[j][k]) +
                          ' data-row=' +
                          this.cryptoService.set(rowMatrix[j]) +
                          '><span data-toggle="tooltip" title="' +
                          rowMatrix[j][k].value
                            ?.toString()
                            .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
                            .replace(/&nbsp;|[^a-zA-Z0-9 @_.&-]/g, '') +
                          '">' +
                          rowMatrix[j][k].value
                            ?.toString()
                            .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
                            .replace(/&nbsp;|[^a-zA-Z0-9 @_.&-]/g, '')
                            .substring(0, 20) +
                          '...</span></a></td>';
                      } else {
                        tableTr +=
                          '<td><span data-toggle="tooltip" title="' +
                          rowMatrix[j][k].value
                            ?.toString()
                            .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
                            .replace(/&nbsp;|[^a-zA-Z0-9 @_.&-]/g, '') +
                          '">' +
                          rowMatrix[j][k].value
                            ?.toString()
                            .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
                            .replace(/&nbsp;|[^a-zA-Z0-9 @_.&-]/g, '')
                            .substring(0, 20) +
                          '...</span></td>';
                      }
                    } else {
                      if (rowMatrix[j][k].colaction == 'Open') {
                        tableTr +=
                          '<td><a class="openReport" data-tabname="' +
                          this.tabName +
                          '" data-obj=' +
                          this.cryptoService.set(rowMatrix[j][k]) +
                          ' data-row=' +
                          this.cryptoService.set(rowMatrix[j]) +
                          '>' +
                          rowMatrix[j][k].value
                            ?.toString()
                            .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
                            .replace(/&nbsp;|[^a-zA-Z0-9 @_.&-]/g, '') +
                          '</a></td>';
                      } else {
                        tableTr +=
                          '<td>' +
                          rowMatrix[j][k].value
                            ?.toString()
                            .replace(/<(?!\/?a(?=>|\s.*>))\/?.*?>/g, '')
                            .replace(/&nbsp;|[^a-zA-Z0-9 @_.&-]/g, '') +
                          '</td>';
                      }
                    }
                  }
                }
              }
            } else {
              tableTr += '<td class="">' + rowMatrix[j][k].value.toString().replace(/,/g, ', ') + '</td>';
            }
          } else {
            tableTr += '<td class=""></td>';
          }
        }
      }
      tableTr += '</tr>';
    }
    return tableTr;
  }

  private getReportDataTableOptions(): object {
    return {
      /** Angular handles sort UI/state; DataTables' own sorting adds duplicate caret classes/icons. */
      ordering: false,
      language: {
        paginate: {
          previous: '',
          next: ''
        },
        lengthMenu: 'Records per page _MENU_ '
      },
      pageLength: 10,
      order: [],
      columnDefs: this.customSortCols,
      lengthMenu: [
        [10, 25, 50, -1],
        [10, 25, 50, 'All']
      ],
      paging: false,
      dom: 'rtlp',
      buttons: [
        {
          extend: 'excel',
          text: '<i class="fa-solid fa-download"></i>',
          title: this.componentContext.name
        }
      ]
    };
  }

  private renderReportTableWithDataTable(tableTr: string): void {
    this.spinnerService.hide();
    this.submitted = false;
    const randomid = this.componentContext.randomid;
    setTimeout(() => {
      const sel = '#data-table' + randomid;
      const $table = $('.pane:visible ' + sel);
      if ($table.length && $.fn.dataTable && $.fn.dataTable.isDataTable($table)) {
        ($table as any).DataTable().destroy(false);
      }
      try {
        $(`#data-table${randomid} [data-toggle='tooltip']`).tooltip('dispose');
      } catch {
        /* noop */
      }
      $('.pane:visible #data-table' + randomid + ' .renderTable').html(tableTr);
      $.fn.dataTable.ext.errMode = 'none';
      ($('.pane:visible ' + sel) as any).dataTable(this.getReportDataTableOptions());
      try {
        $(`.pane:visible ${sel} [data-toggle='tooltip']`).tooltip();
      } catch {
        /* noop */
      }
    }, 500);
  }

  getFilteredData(offsetData) {
    //console.log('save filtered Data');
    this.loading = true;
    $("#data-table" + this.componentContext.randomid + "_wrapper").remove();
    this.submitted = true;
    this.offset = offsetData;
    //console.log(this.queryProcessorFormGroup);
    if (this.queryProcessorFormGroup.invalid) {
      //console.log('Invalid form');
      return;
    }

    let payload: Object;
    payload = {
      "queryId": this.componentContext.id,
      "params": { id: isNaN(this.entitydata.id) ? 0 : this.entitydata.id },
      "offset": parseInt(this.offset),
      "perpage": parseInt(this.perPage)
      // "params": (this.queryProcessorFormGroup.value)? this.queryProcessorFormGroup.value : ""
    }
    //console.log(payload);


    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.customSortCols = [];
    this.outputData = [];
    this.reportApiRowData = [];

    this.subscription = this.queryProcessorService.searchQueriesService(payload).subscribe(data => {
      //console.log('saved query');
      this.loading = false;
      //console.log('sss',data);
      this.queryBuilderEnityName = data.entityName;  
      //this.brodCastChnage.next(this.outputData);               
      for (let j = 0; j < data.rowData.length; j++) {
        //this.rowObj = {};
        if (j == 0) {
          for (let k = 0; k < data.rowData[j].length; k++) {

            if (data.rowData[j][k].dataType == 'Date' || data.rowData[j][k].dataType == 'DateTime') {
              //var nm = data.cols[k].replace(/[^A-Z0-9]+/ig, "");
              this.rowObj = {};
              this.rowObj['type'] = 'de_date';
              this.rowObj['targets'] = k;
              this.customSortCols.push(this.rowObj);
            }
          }

          break;
        }
        // this.rows.push(this.rowObj);    
      }

      this.outputData = data;

      if (data.entityName == 'Metabolic') {
        this.tabName = "Bloodspot";
      } else {
        this.tabName = data.entityName;
      }
      this.entity = data.entityName;
      this.reportSortColumnIndex = null;
      this.reportSortAscending = true;
      this.searchtext = '';
      this.reportApiRowData = Array.isArray(data.rowData)
        ? (data.rowData as any[][]).map((row: any[]) => row.slice())
        : [];
      this.applyReportFilterAndSort();

    },
      error => {
       // console.log('error in searchQueriesService');
        this.submitted = false;
      });
    // this.submitted = false;
  }
  randomId() {
    return Math.floor(Math.random() * (999 - 100 + 1) + 100) + Date.now();
  }
  public componentSelectionEmitter(componentData: object) {
    //console.log(componentData);
    setTimeout(() => {
      this._ngZone.run(() => {
        this.componentSelection.emit(componentData);
      })
    },200)
  }
  public prev() {
    //console.log(this.offset);
    //console.log(this.pageNo);
    if (this.offset > 0) {
      this.offset = parseInt(this.offset) - parseInt(this.perPage);
      this.pageNo--;
      this.getFilteredData(this.offset);
    }
  }
  public next() {
    if (this.outputData && this.outputData.rows.length > 0) {
      this.offset = parseInt(this.offset) + parseInt(this.perPage);
      //console.log(this.offset)
      this.pageNo++;
      this.getFilteredData(this.offset);
    }
  }
  chunk(arr, size) {
    var newArr = [];
    for (var i = 0; i < arr.length; i += size) {
      newArr.push(arr.slice(i, i + size));
    }
    return newArr;
  }
  edit(data, enityName, id, cols) {
    //console.log(cols);
    //console.log(data);  
    //console.log(enityName);
    this._ngZone.run(() => {
      this.rowData = data;
      this.editEnityName = enityName;
      this.editID = id;
      this.metadata.getObjectMetaData(this.editEnityName).subscribe((data: any) => {
        //console.log("Get Object MetaData",data);
        this.objectMetaData = data;
        for (var i = 0; i < this.rowData.length; i++) {
          if (this.rowData[i].editable) {
            if (this.rowData[i].dataType == 'Picklist') {
              //console.log(this.rowData[i].colName);
              let objDetails = this.objectMetaData.columnNames[this.rowData[i].colName];
              let sortable: any = [];
              //console.log(objDetails);
              if (objDetails.hasOwnProperty('pickListValues')) {
                for (var it in objDetails.pickListValues.newIdValues) {
                  if (objDetails.pickListValues.newIdValues[it].active == true) {
                    let objSorted: any = {};
                    objSorted.option_label = objDetails.pickListValues.newIdValues[it].value;
                    objSorted.option_value = parseInt(it.replace('key_', ''));
                    if (objSorted.option_label == this.rowData[i].value) {
                      this.rowData[i].dbValue = objSorted.option_value;
                    }
                    sortable.push(objSorted);
                  }
                }
                sortable.sort(this.sus.SortByName);
              }
              this.rowData[i].pickListValues = sortable;
            }
          }
        }
        this.createEditForm(cols);
      })
    })
  }
  createEditForm(cols) {
    this.reportData = [];
    this.headings = cols;

    for (var i = 0; i < this.rowData.length; i++) {
      if (this.rowData[i].dataType != 'ACTION') {
        if (this.rowData[i].editable) {
          let tempObj: any = {};
          tempObj.label = this.headings[i];
          if (this.rowData[i].dataType == 'Date' || this.rowData[i].dataType == 'DateTime') {
            tempObj.value = this.sus.getDateByFormat(this.rowData[i].value, '-', 'ymd');
          } else if (this.rowData[i].dataType == 'Picklist') {
            tempObj.pickListValues = this.rowData[i].pickListValues;
            tempObj.value = this.rowData[i].dbValue;
          } else {
            tempObj.value = this.rowData[i].value;
          }
          tempObj.formControlName = this.rowData[i].colName;
          tempObj.required = true;
          tempObj.dataType = this.rowData[i].dataType;
          this.reportData.push(tempObj);
        }
      } else {
        if (this.rowData[i].action.actionType == 'Edit') {
          let tempObj: any = {};
          tempObj.formControlName = 'id';
          tempObj.value = this.rowData[i].action.value;
          tempObj.dataType = 'Edit';
          tempObj.label = '';
          this.reportData.push(tempObj);
        }
      }
    }
    //console.log(this.reportData);
    //Creating fields and validation------//////////////////////
    for (var i = 0; i < this.reportData.length; i++) {
      let formControlData: any = [];
      if (this.reportData[i].required) {
        formControlData.push(this.reportData[i].value);
        //formControlData.push(Validators.required);
      } else {
        formControlData.push(this.reportData[i].value);
      }
      this.fbGpObject[this.reportData[i].formControlName] = formControlData;

    }

    //console.log(this.fbGpObject);
    //this.reportData = this.chunk(this.reportData,0);

    //Creating dynamic report form group//////////////////////////////////
    this.editReportForm = this.formBuilder.group(this.fbGpObject);
    this.modalService.open(this.reportPopupForm, { backdrop: 'static', keyboard: false, windowClass: 'modal-lg animate reportForm' })
  }
  get editReportFormData() { return this.editReportForm.controls; }
  onSubmitEditReport(c) {

    this.submitted = true;
    //console.log(this.editReportForm.invalid);
    if (this.editReportForm.invalid) {
      return;
    }
    //console.log(this.editReportForm.value);return false;
    for (let i in this.editReportForm.value) {
      if (this.objectMetaData.columnNames[i].Datatype == 'Date') {
        this.editReportForm.value[i] = this.sus.getTimeStampDate(this.editReportForm.value[i]);
      } else if (this.objectMetaData.columnNames[i].Datatype == 'DateTime') {
        this.editReportForm.value[i] = this.sus.getTimeStampDate(this.editReportForm.value[i]);
      } else if (this.objectMetaData.columnNames[i].Datatype.toLowerCase() == 'picklist') {
        this.editReportForm.value[i] = parseInt(this.editReportForm.value[i]);
      }
    }
    //this.editReportForm.value

    let payload: any = {
      "entityName": this.editEnityName,
      "payLoad": this.editReportForm.value
    }
    //console.log(payload);return false;
    this.objc.queryReportCreate(payload).subscribe((success) => {
      //console.log(success);
      c('Close');
      if (success.payLoad) {
        Swal.fire({
          title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Saved successfully!</div></div>',
          icon: 'success',
          imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
imageHeight: 45,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: `Done `,
        })
        this.getFilteredData(this.offset);
      } else {
        Swal.fire('Oops...!', 'Something went wrong, Please try again.', 'error');
      }
    })
    //console.log("Get Object MetaData",this.objectMetaData);
  }
  convertDate(data) {
    return this.sus.getDate(data);
  }
  toggle() {
    this.isCollapsed = !this.isCollapsed;
  }
  refresh(){    
    this.ngAfterViewInit();
  }
  addNew(){

    //// console.log(this.entitydata);
    //// console.log(this.referredEntity);
    //// console.log(this.referredColumn);
    // alert(this.editEnityName)
    // alert(this.entitydata.name);
    //return false;
    if(this.entitydata.id > 0){
      this.queryProcessorService.getLookupName(this.entitydata.id,this.entitydata.entityName).subscribe(data=>{
       
           let d = { 
            id: -1, 
            name: this.referredEntity,
            referredColumn:this.referredColumn, 
            type: 'object', 
            entityName: this.referredEntity,
            parentID: this.entitydata.id,          
            lookupData:{'id':this.entitydata.id,'text':data,'selected':true}  ,
            category:this.componentContext.type          
          };
        
       // console.log(d);
        //return false;
        this.componentSelectionEmitter(d);
      })
   }
    
  }
  perPagechange() {
    this.pageNo = 1;
    this.searchtext = '';
    this.getFilteredData(0);
  }
  reloadPage(){
    this.getFilteredData(0);   
  }
  
}

